import { ActionIcon, Avatar, Badge, Box, Button, Divider, Grid, Group, Menu, Modal, Paper, Progress, Skeleton, Stack, Text, Title, Tooltip, UnstyledButton } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import React, { useEffect, useMemo, useRef } from 'react';
import { FaArchive, FaCalendar, FaEdit, FaEllipsisV, FaEye, FaPlus, FaTrash } from 'react-icons/fa';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate, useSearchParams } from 'react-router-dom';
import InputField, { InputFieldTypes } from '../components/input_field';
import { useApp } from '../contexts/app.context';
import { useAuth } from '../contexts/auth.context';
import { ARCHIVE_JOB, DELETE_JOB, GET_ALL_JOBS, SAVE_JOB } from '../services/jobs';
import { getExtenseDatetime, useQuery } from '../utility/util';

export default function JobsPage() {
    const [openDone, setOpenDone] = React.useState(false);
    const [period, setPeriod] = React.useState([null, null]);

    const query = useQuery();
    const customerId = query.get("cliente");
    const agentId = query.get("responsavel");

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { confirmDialog, customers, configs, agents } = useApp();
    const { role } = useAuth();
    const viewType = query.get("present");


    return <Stack spacing={0}>
        {/* <Title order={3} color={configs?.contrast}>Jobs</Title> */}
        <Grid align='flex-end' justify='flex-end'>
            {role && <Grid.Col md={2}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    value={agentId}
                    name={"agent"}
                    size="md"
                    placeholder="Responsável"
                    options={agents.map(a => ({ label: a.name, value: a._id }))}
                    onChange={({ agent }) => {
                        if (["null", null, undefined].includes(agent) || agentId === agent) {
                            searchParams.delete("responsavel");
                            setSearchParams(searchParams);
                        } else {
                            searchParams.set("responsavel", agent);
                            setSearchParams(searchParams);
                        }
                    }}
                />
            </Grid.Col>}
            {role && <Grid.Col md={2}>
                <InputField
                    fieldType={InputFieldTypes.SELECT}
                    value={customerId}
                    name={"customer"}
                    size="md"
                    placeholder="Cliente"
                    options={customers.filter(c => c.active).map(a => ({ label: a.name, value: a._id }))}
                    onChange={({ customer }) => {
                        if (["null", null, undefined].includes(customer) || customerId === customer) {
                            searchParams.delete("cliente");
                            setSearchParams(searchParams);
                        } else {
                            searchParams.set("cliente", customer);
                            setSearchParams(searchParams);
                        }
                    }}
                />
            </Grid.Col>}
            <Grid.Col md={2}>
                <Text size="xs" color={configs?.contrast}>Data Inicial</Text>
                <InputField
                    fieldType={InputFieldTypes.DATE}
                    value={period[0]}
                    name="start"
                    size="md"
                    placeholder="Data Inicial"
                    onChange={({ start }) => setPeriod(p => [start, p[1]])}
                />
            </Grid.Col>
            <Grid.Col md={2}>
                <Text size="xs" color={configs?.contrast}>Data Final</Text>
                <InputField
                    fieldType={InputFieldTypes.DATE}
                    value={period[1]}
                    name="finish"
                    size="md"
                    placeholder="Data Final"
                    onChange={({ finish }) => setPeriod(p => [p[0], finish])}
                />
            </Grid.Col>
            {role && <Grid.Col md={2}>
                <Button
                    fullWidth
                    size="md"
                    color="gray"
                    onClick={() => setOpenDone(true)}
                >Arquivados</Button>
            </Grid.Col>}
            <Grid.Col md={2}>
                <Button
                    fullWidth
                    size="md"
                    leftIcon={<FaPlus />}
                    onClick={() => { navigate(role ? "/jobs/novo" : "/solicitar") }}
                >Job</Button>
            </Grid.Col>
            {/* <Tooltip label="Alterar Visualização">
                        <ActionIcon
                            size="xl"
                            variant="light"
                            color='gray'
                            onClick={() => {
                                searchParams.set("present", viewType === "calendar" ? "kanbam" : "calendar");
                                setSearchParams(searchParams);
                            }}
                        >
                            {viewType === "calendar" ? <FaCalendar /> : <FaPause />}
                        </ActionIcon>
                    </Tooltip> */}
            <Grid.Col md={12} mt="md">
                <Grid>
                    <Grid.Col xs={6} md={3} style={{ padding: 2 }}>
                        <JobsBoard
                            statusKey="draft"
                            title={role ? "Rascunho" : "Solicitações"}
                            customerId={customerId}
                            agentId={agentId}
                            period={period}
                        />
                    </Grid.Col>
                    <Grid.Col xs={6} md={3} style={{ padding: 2 }}>
                        <JobsBoard
                            statusKey="to-approve"
                            title="Para aprovação"
                            customerId={customerId}
                            agentId={agentId}
                            period={period}
                        />
                    </Grid.Col>
                    <Grid.Col xs={6} md={3} style={{ padding: 2 }}>
                        <JobsBoard
                            statusKey="adjust"
                            title="Em ajustes"
                            customerId={customerId}
                            agentId={agentId}
                            period={period}
                        />
                    </Grid.Col>
                    <Grid.Col xs={6} md={3} style={{ padding: 2 }}>
                        <JobsBoard
                            statusKey="approved"
                            title="Aprovado"
                            customerId={customerId}
                            agentId={agentId}
                            period={period}
                        />
                    </Grid.Col>
                </Grid>
                {/* <Table
            columns={[
                { title: "Cliente", key: "customer", render: item => <CustomerAvatar name={item?.customer?.name} /> },
                { title: "Nome do JOB", key: "name" },
                { title: "Itens", key: "tasks", render: item => (item.tasks || []).map(t => <div>{t.name}</div>) },
                { title: "Última atualização", key: "last_update", render: item => moment(item.last_update).format("DD/MM/YYYY HH:mm:ss") },
                { title: "Status", key: "status", render: item => <Badge color={item.statusCategory === "done" ? "green" : item.statusCategory === "pendent" ? "gray" : "blue"}>{item.status}</Badge> },
            ]}
            actions={[
                {
                    title: "Editar",
                    color: "blue",
                    onClick: ({item}) => {
                        navigate(role ? `/jobs/${item.id}` : `/j/${item.id}`)
                    }
                },
                {
                    title: "Deletar",
                    color: 'red',
                    onClick: ({item}) => {
                        app.confirmDialog(
                            {text: "Realmente deseja deletar?"},
                            (({confirmed}) => {
                                if(confirmed) deleteItem(item.id);
                            })
                        )
                    }
                },
            ]}
            data={items}
        /> */}
            </Grid.Col>
        </Grid>

        <Modal.Root
            opened={openDone}
            onClose={() => { setOpenDone(false) }}
            size="sm"
        >
            <Modal.Overlay />
            <Modal.Content id='done-modal-scroll'>
                {openDone && <JobsBoard
                    scrollId='done-modal-scroll'
                    statusKey='' title="Arquivados" period={period} agentId={agentId} customerId={customerId} archived={true} />}
            </Modal.Content>
        </Modal.Root>
    </Stack>
}

const JobsBoard = ({ statusKey = "draft", scrollId = undefined, title, customerId = null, agentId = null, period, archived = false }) => {
    const [jobs, setJobs] = React.useState<any[]>([]);
    const [loadingJobs, setLoadingJobs] = React.useState<boolean>(false);
    const [approvalType, setApprovalType] = React.useState(null);
    const [total, setTotal] = React.useState(null);
    const [hasMore, setHasMore] = React.useState(true);

    const { role } = useAuth();
    const { agents, confirmDialog } = useApp();

    const navigate = useNavigate();
    const pageRef = useRef(0);

    const filters = useMemo(() => ({
        statusKey,
        archived,
        deadlineStart: period[0],
        deadlineEnd: period[1],
        agentId,
        customerId
    }), [statusKey, archived, period, agentId, customerId])

    const loadJobs = () => {
        setLoadingJobs(true);
        GET_ALL_JOBS({
            ...filters,
            page: pageRef.current,
        })
            .then(({ items = [], total }) => {
                setJobs(j => [...j, ...items]);
                setTotal(total);
                setHasMore(items.length >= 10);
            })
            .catch((err) => {
                showNotification({
                    title: "Ops",
                    message: err.message,
                    color: "red",
                });
            })
            .finally(() => {
                setLoadingJobs(false);
            })
    };

    const archiveJob = (jobId, archive = true) => {
        let previous = [...jobs];
        setJobs(i => i.map(j => j.id === jobId ? { ...j, archived: archive } : j))
        ARCHIVE_JOB(jobId, archive)
            .then(res => {
                showNotification({ message: "O job foi arquivado", color: "green" });
            })
            .catch(err => {
                setJobs(previous);
                showNotification({ title: "Ops", message: err.message, color: 'red' })
            })
    }

    const deleteJob = (jobId) => {
        let previous = [...jobs];
        setJobs(i => i.filter(j => j.id !== jobId))
        DELETE_JOB(jobId)
            .then(res => {
                showNotification({ message: "O job foi deletado", color: "green" });
            })
            .catch(err => {
                setJobs(previous);
                showNotification({ title: "Ops", message: err.message, color: 'red' })
            })
    }

    const updateJob = (jobId, dt) => {
        const prev = jobs.find(jb => jb.id === jobId)
        setJobs(jbs => jbs.map(jb => jb.id === jobId ? { ...jb, ...dt } : jb))
        SAVE_JOB({ ...dt, id: jobId })
            .then(() => { })
            .catch((err) => {
                showNotification({ color: 'red', message: err.message })
                setJobs(jbs => jbs.map(jb => jb.id === jobId ? prev : jb))
            })
    }

    const getApprovalTypes = (item: any): { [key: string]: { tasks: any[] } } => {
        const types = {
            approved: { tasks: [] },
            scheduled: { tasks: [] },
            published: { tasks: [] },
            failed: { tasks: [] },
        };
        (item.tasks ?? []).forEach(task => {
            const destinations = (task.destinations ?? []).filter(dest => dest?.allow_schedule)
            if (destinations.length === 0) {
                types.approved.tasks.push(task);
            } else {
                if (destinations.some(dest => (
                    (dest.publications ?? []).some(pub => pub.error)) &&
                    !(dest.publications ?? []).some(pub => !pub.error)
                )) types.failed.tasks.push(task);
                else if (
                    destinations.every(dest => (
                        (dest.publications ?? []).some(pub => !pub.error))
                    )
                ) {
                    types.published.tasks.push(task);
                } else {
                    types.scheduled.tasks.push(task);
                }
            }
        });

        return types;
    }

    const getItems = (approvalStatus = null) => (
        jobs
            .filter(i => (
                (!approvalStatus || (getApprovalTypes(i)[approvalStatus]?.tasks ?? []).length > 0)
            ))
        // .sort((a, b) => a.last_update > b.last_update ? -1 : 1)
    )

    const renderItem = (item, index) => {
        return <Paper key={`${item.id}`} p="md" mb="xs" shadow='xs'>
            <UnstyledButton
                style={{ width: "100%" }}
                onClick={() => {
                    navigate(role ? `/jobs/${item.id}` : `/jobs/${item.id}`)
                }}
            >
                <Group style={{ justifyContent: 'space-between' }}>
                    <Box pb="xs">
                        <Text size="md" weight="bold">{item.name}</Text>
                        <Text size="sm" color="gray">{item?.customer?.name}</Text>
                    </Box>
                </Group>
                {item.deadline && <Group spacing={2} mb="md" position='right'>
                    <Text size="xs" color="#BABABA">{getExtenseDatetime(item.deadline)}</Text>
                    <FaCalendar color="#BABABA" />
                </Group>}
                {item.statusKey !== "approved" && (item?.customer?.flow ?? []).map((flow, index) => {
                    const totalTasks = (item.tasks || []).length;
                    const isApproved = (item?.flow ?? []).length > index;

                    const qtToApprove = isApproved ? 0 :
                        item.tasks.filter((t) => [null, undefined, "draft", "to-approve"].includes(t.currentStatusKey)).length;
                    const qtAdjust = isApproved ? 0 :
                        item.tasks.filter((t) => ["adjust"].includes(t.currentStatusKey)).length;
                    const qtApproved = (item?.flow ?? []).length > index
                        ? totalTasks
                        : item.tasks.filter((t) => ["approved"].includes(t.currentStatusKey)).length;

                    return <Progress
                        mb="xs"
                        size="xl"
                        sections={[
                            {
                                label: "Aguardando aprovação", value: totalTasks === 0
                                    ? 0
                                    : (qtToApprove * 100) / totalTasks, color: "gray",
                                tooltip: `${qtToApprove} - Aguardando aprovação`
                            },
                            {
                                label: "Em Ajuste", value: totalTasks === 0
                                    ? 0
                                    : (qtAdjust * 100) / totalTasks, color: "yellow",
                                tooltip: `${qtAdjust} - Em Ajuste`
                            },
                            {
                                label: isApproved ? flow.title ?? `Nível ${index + 1}` : `Aprovado`, value: totalTasks === 0
                                    ? 0
                                    : (qtApproved * 100) / totalTasks, color: "green",
                                tooltip: `${qtApproved} - Aprovados`
                            },
                        ]}
                    />
                })}
            </UnstyledButton>
            <Group style={{ justifyContent: 'space-between' }}>
                <Menu>
                    <Menu.Target>
                        <UnstyledButton>
                            <Group>
                                <Tooltip label={item?.responsible?.name ?? "Sem responsável"}>
                                    <Avatar src={item?.responsible?.image} />
                                </Tooltip>
                            </Group>
                        </UnstyledButton>
                    </Menu.Target>
                    <Menu.Dropdown>
                        {
                            agents.map(user => (
                                <Menu.Item
                                    onClick={() => { updateJob(item.id, ({ responsible: { _id: user._id, name: user.name, image: user.image } })) }}
                                    icon={<Avatar size="sm" src={user.image} />}
                                    disabled={user?._id === item?.responsible?._id}>{user.name}</Menu.Item>
                            ))
                        }
                    </Menu.Dropdown>
                </Menu>
                <Text color="dark" style={{ flex: 1 }} pl="xs" size="xs">{(item.tasks || []).length} itens</Text>
                {role && <Menu>
                    <Menu.Target>
                        <ActionIcon color="dark"><FaEllipsisV /></ActionIcon>
                    </Menu.Target>
                    <Menu.Dropdown>
                        <Menu.Item color="dark" icon={<FaEye />} onClick={() => navigate(`/jobs/${item.id}`)}>Visualizar</Menu.Item>
                        <Menu.Item color="dark" icon={<FaEdit />} onClick={() => navigate(`/jobs/${item.id}?u=true`)}>Editar</Menu.Item>
                        <Menu.Item color="yellow" icon={<FaArchive />} onClick={() => {
                            confirmDialog({ text: `Realmente deseja ${item.archived ? "desarquivar" : "arquivar"} o job?` }, ({ confirmed }) => {
                                if (confirmed) archiveJob(item.id, !item.archived);
                            })
                        }}>{item.archived ? "Desarquivar" : "Arquivar"}</Menu.Item>
                        <Menu.Item color="red" icon={<FaTrash />} onClick={() => {
                            confirmDialog({ text: "Realmente deseja deletar o job?" }, ({ confirmed }) => {
                                if (confirmed) deleteJob(item.id);
                            })
                        }}>Deletar</Menu.Item>
                    </Menu.Dropdown>
                </Menu>}
            </Group>
        </Paper>
    }

    useEffect(() => {
        setHasMore(true);
        setJobs([]);
        pageRef.current = 0;
        loadJobs();
    }, [filters]);

    return <Paper p="md" shadow='xs'>
        <Group spacing={0}>
            <Badge color="gray">{total}</Badge>
            <Title style={{ flex: 1, whiteSpace: 'nowrap' }} order={5} ta="center">{title}</Title>

            {statusKey === "approved" && <Menu>
                <Menu.Target><ActionIcon><FaEllipsisV /></ActionIcon></Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item
                        color={!approvalType ? "dark" : undefined}
                        onClick={() => setApprovalType(null)}
                    >Todos ({getItems().length})</Menu.Item>
                    <Menu.Item
                        color={approvalType === "approved" ? "dark" : undefined}
                        onClick={() => setApprovalType("approved")}
                    >Aprovados ({getItems("approved").length})</Menu.Item>
                    <Menu.Item
                        color={approvalType === "scheduled" ? "dark" : undefined}
                        onClick={() => setApprovalType("scheduled")}
                    >Agendados ({getItems("scheduled").length})</Menu.Item>
                    <Menu.Item
                        color={approvalType === "published" ? "dark" : undefined}
                        onClick={() => setApprovalType("published")}
                    >Publicados ({getItems("published").length})</Menu.Item>
                    <Menu.Item
                        color={approvalType === "failed" ? "dark" : undefined}
                        onClick={() => setApprovalType("failed")}
                    >Com Falha ({getItems("failed").length})</Menu.Item>
                </Menu.Dropdown>
            </Menu>}
            {/* <Menu>
                <Menu.Target><ActionIcon><FaEllipsisV /></ActionIcon></Menu.Target>
                <Menu.Dropdown>
                    <Menu.Item color="dark">Todos</Menu.Item>
                </Menu.Dropdown>
            </Menu> */}
        </Group>
        <Divider mt="xs" mb="xs" />

        <InfiniteScroll
            dataLength={jobs.length}
            next={() => {
                pageRef.current = pageRef.current + 1;
                loadJobs()
            }}
            scrollableTarget={scrollId}
            hasMore={hasMore}
            loader={<Stack>
                {Array.from({ length: 10 }).map(() => <Skeleton animate variant="rectangular" height={100} />)}
            </Stack>}
            endMessage={<p style={{ textAlign: 'center' }}></p>}
        >
            {getItems(approvalType).map(renderItem)}
        </InfiniteScroll>
    </Paper>
}